import React from 'react';
import styled from 'styled-components';
import { SecondaryProductSelectListPropsType } from '../../model';
import { SecondaryProductDisplayModalView } from '../secondary-product-display';

export function SecondaryProductSelectListModal({
  secondaryProductKeys,
  selectedSecondaryProductKey,
  setSelectedSecondaryProductKey
}: SecondaryProductSelectListPropsType) {
  return (
    <SecondaryProductSelectionListModalContainer>
      {secondaryProductKeys.length > 0 &&
        secondaryProductKeys.map((productKey: string, index) => (
          <SecondaryProductDisplayModalView
            btnId={index}
            key={productKey}
            productKey={productKey}
            selected={selectedSecondaryProductKey === productKey}
            onSelect={() => {
              if (selectedSecondaryProductKey === productKey) {
                setSelectedSecondaryProductKey('');
              } else {
                setSelectedSecondaryProductKey(productKey);
              }
            }}
          />
        ))}
    </SecondaryProductSelectionListModalContainer>
  );
}

export const SecondaryProductSelectionListModalContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  justify-content: center;
`;
